import React, { useState } from "react";
import ReactDOM from "react-dom";
import CloseCommand from "../Commands/CloseCommand/CloseCommand";
import "./SimpleModal.css";

export default function CustomAlert (props)  {
  
 return ReactDOM.createPortal(
        <React.Fragment>
          <div className="modal-overlay"  />
          <div
            className="modal-wrapper"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
            
          >
            <div className="modal" style = {{width:props.width}}>
              <div className="modal-line">    
                <div className="header-left">
                {props.title}
                </div>        
                <div className="header-right">
                  <CloseCommand onClick={props.hide} />
                </div>
              </div>  
              <div>
              <div className="modal-line" style = {{color:"gray", fontSize:"14px"}}>
                {props.text}
              </div>

              </div>        
              <div className="modal-line-right">
                <div onClick={props.hide} >
                  <input style ={{ backgroundColor: "#008dff", fontSize:"12px", height: "20px", padding: "0px", width: "70px", }} type="button" className="button" value="Ok"/>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>,
        document.body
      )
  }

